<div class="common-button">
  <button [id]="id" [ngClass]="{'white-button': type === 'white', 'blue-button': type === 'blue', 'blue-button-outline': type === 'blue-button-outline', 'red-button': type === 'red', 'green-button': type === 'green', 'grey-button': type === 'grey',
          'bright-white-button': type === 'bright white'}" (click)="handleClick($event)" [disabled]="disabled">
    <span class="icon" *ngIf="existIcon && iconUrl"
      [ngStyle]="{'background-image': 'url('+ iconUrl +')'}"></span>
    <span class="text">{{title}}</span>
  </button>
</div>
